import React from 'react';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';
import capitalizeClientName from '../../../../Components/Utils/Captailize';

function getInitials(name) {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
}

function OpenTask() {
  const { data , loading } = UseGetDashBoardData(`/dashboard/open-tasks`);
  console.log(data,"hgh");
  

  const totalOpenTasks = Array.isArray(data)
    ? data.reduce((acc, curr) => acc + (curr.openTasks || 0), 0)
    : 0;

  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-bold text-gray-700">Open Tasks</h2>
        <span className="text-xs bg-yellow-100 text-gray-800 font-bold px-1.5 py-1 rounded-lg shadow">
          {totalOpenTasks}
        </span>
      </div>

      {/* Task List */}
      <div className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent h-full pr-1">
        <div className="space-y-3">
          {data.length > 0 ? (
            data.map((task, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between border p-2 rounded-xl hover:bg-gray-50 hover:shadow-md transition duration-200"
              >
                <div className="flex items-center gap-3">
                <div className="bg-yellow-500 text-white font-bold w-8 h-8 text-[10px] rounded-full flex items-center justify-center shadow-inner">
  {getInitials(task.clientName)}
</div>

                  <p className="text-xs  font-medium text-gray-600">
  {capitalizeClientName(task.clientName)}
</p>
    </div>

                <span className="bg-white text-yellow-600 border border-yellow-300 text-xs font-semibold px-2 py-1 rounded-full shadow-sm">
                  {task.openTasks}
                </span>
              </div>
            ))
          ) : (
            <p className="text-xs text-gray-400">No open tasks found</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default OpenTask;
